// src/views/CalendarView.tsx

// 日历视图

// 第三方
// import axios from 'axios'
import React from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'

// 自定义
import Header from '../components/Header'
import Sidebar from '../components/Sidebar'
import { Global } from '../services/Global'
import { browserUtil } from '../utils/BrowserUtil'
import CalendarContent from '../components/CalendarContent'
// import { strUtil } from '../utils/StrUtil'
// import { ROLE } from '../services/Macro'
// import { encrypUtil } from '../utils/EncrypUtil'
// import { CalendarApi } from '../services/Api'
// import { timeUtil } from '../utils/TimeUtil'

class CalendarView extends React.Component<WithTranslation> {

    state = {
        showWarn: false,
        showConfirm: false,
        warnTitle: '本地错误',
        warnInfo: '参数错误',
        confirmOp: () => { console.log('do nothing!') },
        loginName: '',
        // recordMap: new Map(),
    }

    componentWillMount = () => {
        Global.isMobile = browserUtil.checkMobile()
    }

    componentDidMount = () => {
        // this.requestRecords()
    }

    // /** 请求记录数据 */
    // requestRecords = async () => {
    //     const DEBUG = true
    //     const TAG = `CalendarView.requestRecords() - `
    //     let dayCountPerMonth = 30
    //     let count = 1
    //     let map: Map<number, any> = new Map()
    //     while (count <= dayCountPerMonth) {
    //         const uuid = 'system'
    //         let token = localStorage.getItem('token') || null
    //         let lang = localStorage.getItem('lang') || 'zh_CN'
    //         let dayStr = strUtil.fillPrev(`${count}`, 2, '0')
    //         let date = `2025-03-${dayStr}`
    //         // 请求页面数据
    //         let requestData = {
    //             role: ROLE.SUPER,
    //             token: token,
    //             // uuid: uuid,
    //             lang: lang.split('_')[0],
    //             page: 1,
    //             size: 3,
    //             date: date
    //         }
    //         // DEBUG && console.log(TAG, `requestData:\n`, requestData)
    //         let params = await encrypUtil.encodeRequestRsa(requestData)
    //         // DEBUG && console.log(TAG, `params:\n`, params)
    //         const response = await axios.post(CalendarApi.GET_RECORD_LIST_BY_DATE, params)
    //         if (response && response.data && response.data.data && response.data.data.count > 0) {
    //             DEBUG && console.log(TAG, `response.data:\n`, response.data.data)
    //             let recordList: any[] = []
    //             let showData = {
    //                 count: response.data.data.count,
    //                 recordList: recordList
    //             }
    //             for (let i = 0; i < response.data.data.list.length; i++) {
    //                 let record = response.data.data.list[i]
    //                 let name = record.meta.name ? record.meta.name : 'unknown'
    //                 showData.recordList.push({
    //                     time: timeUtil.getMonthDayFromTimestamp(record.create),
    //                     name: name,
    //                     age: record.age,
    //                     gendar: record.gemder,
    //                 });
    //             }
    //             map.set(count, showData)
    //             this.setState({ recordMap: map })
    //         }
    //         count++
    //     }
    //     // this.setState({recordMap: map})
    // }

    changeLang = () => {
    }

    render() {
        const { t, i18n } = this.props
        return (
            <section className="body">
                <Header trans={t} i18n={i18n} loginName={this.state.loginName} changeLang={this.changeLang}></Header>
                <div className="inner-wrapper">
                    <Sidebar selectMenu="calendar" trans={t}></Sidebar>
                    <CalendarContent
                        trans={t}
                        i18n={i18n}
                        // recordMap={this.state.recordMap}
                    >
                    </CalendarContent>
                </div>
            </section>
        )
    }

}
export const CalendarPage = withTranslation()(CalendarView)